export default __webpack_public_path__ + "static/media/wheel.a3bc733d.png";